import { render, staticRenderFns } from "./scanList.vue?vue&type=template&id=19b895a0&scoped=true&"
import script from "./scanList.vue?vue&type=script&lang=js&"
export * from "./scanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b895a0",
  null
  
)

export default component.exports